import { render, staticRenderFns } from "./InfoDemande.vue?vue&type=template&id=f58f1600"
import script from "./InfoDemande.vue?vue&type=script&lang=js"
export * from "./InfoDemande.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports